import { apiFetch, readApiJson } from '../../api/http';

async function handleRequest(age = '4y', subject = 'Общее') {
    const url = `/getCriterion?age=${encodeURIComponent(age)}&subject=${encodeURIComponent(subject)}`;
    const response = await apiFetch(url);
    const { ok, body, message } = await readApiJson(response);

    if (!ok || !body || body.success !== true) {
        const err = new Error(message || 'Не удалось загрузить критерии');
        err.apiMessage = message;
        throw err;
    }

    const result = {};
    const data = body.data;
    if (data && typeof data === 'object') {
        for (const key in data) {
            const item = data[key];
            if (item && typeof item === 'object') {
                for (const category in item) {
                    result[category] = item[category];
                }
            }
        }
    }

    return result;
}

export { handleRequest };
